module.exports = __webpack_public_path__ + "img/yun-jin.8fc38f78.webp";